import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { locationService } from "@project/services/admin/location.service";
import type { District } from "@project/types/location";

const fields: Field[] = [
  {
    name: "name",
    label: "District Name",
    required: true,
    showInTable: true,
    placeholder: "Ahmedabad District",
  },
  { name: "is_active", label: "Active", type: "boolean", showInTable: true },
];

export default function Page() {
  return (
    <AdminShell
      title="Districts"
      subtitle="Manage districts for location master data"
    >
      <ApiResourceTable<District>
        title="District"
        fields={fields}
        searchFields={["name"]}
        defaultValues={{ is_active: true }}
        list={query => locationService.listDistrictsPage(query)}
        create={payload =>
          locationService.createDistrict(
            payload as { name: string; is_active: boolean }
          )
        }
        update={(id, payload) =>
          locationService.updateDistrict(
            id,
            payload as { name: string; is_active: boolean }
          )
        }
        remove={id => locationService.deleteDistrict(id)}
      />
    </AdminShell>
  );
}
